var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Image from '@jetshop/ui/Image/Image';
import { Price } from '@jetshop/ui/Price';
import ProductLink from '@jetshop/ui/ProductLink';
import React from 'react';
import styled, { css } from 'react-emotion';
import Badges from './Badges';
export const ProductWrapper = styled('div') `
  width: 50%;
  ${({ theme }) => theme.above.md} {
    width: 33.333%;
  }
  ${({ theme }) => theme.above.lg} {
    width: 20%;
  }
`;
export const ProductBlockLink = styled(ProductLink) `
  text-decoration: none;
  color: inherit;
  display: block;
  margin-right: ${({ theme }) => theme.space[1]};
  margin-left: ${({ theme }) => theme.space[1]};
  margin-bottom: 36px;
  border: 1px solid #ededed;
  background-color: white;
`;
export const ProductDetails = styled('div') `
  background-color: white;
  padding: 8px;
  max-width: 100%;
  max-height: 100%;
`;
export const Name = styled('p') `
  font-weight: 600;
`;
const GridProduct = (_a) => {
    var { product, categoryPath, loading, imageAspect = '1:1', className = '', search, hash, listName } = _a, rest = __rest(_a, ["product", "categoryPath", "loading", "imageAspect", "className", "search", "hash", "listName"]);
    return (React.createElement(ProductWrapper, Object.assign({ "data-testid": "product", className: className }, rest),
        React.createElement(ProductBlockLink, { list: listName, search: search, hash: hash, product: product, categoryPath: categoryPath, className: loading &&
                css `
          opacity: 0.5;
        ` },
            product.images.length > 0 && (React.createElement(Image, { sizes: [1 / 4, 1 / 3, 1 / 2, 1 / 2], aspect: imageAspect, alt: product.images[0].alt, src: product.images[0].url },
                React.createElement(Badges, { badges: product.badges }))),
            React.createElement(ProductDetails, null,
                React.createElement(Name, null, product.name),
                React.createElement("p", { className: "sub-name" }, product.subName),
                React.createElement(Price, { price: product.price, previousPrice: product.previousPrice })))));
};
export default GridProduct;
//# sourceMappingURL=GridProduct.js.map